import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { ConvertCappedToFlexiClient } from "../../../../../../Wrap/Api/Drawdown/ConvertCappedToFlexi";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { InstructionStatus } from "../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { ConvertCappedToFlexiModel } from "../../../../../../Wrap/Models/Models/Processes/Drawdown/ConvertCappedToFlexiModel";
import { ConvertToFlexiInstructionDispatcher, ConvertToFlexiInstructionStore } from "../Store/Variable";

export class ConvertToFlexiAction {
    public static getInstruction(hierarchyId: string, instructionId: number): void {
        const client = new ConvertCappedToFlexiClient();
        if (instructionId && instructionId != undefined) {
            //Have instruction
            const promise = client.get(
                instructionId
            );
            this.updateConvertToFlexiInstructionStore(promise);
        }
        else {
            //Create new instruction
            const promise = client.post(hierarchyId);
            promise.onSuccess((result) => {
                const instructionId = result.Result;
                const model = client.get(instructionId);
                this.updateConvertToFlexiInstructionStore(model);
            })
        }
    }

    public static saveInstruction(data: ConvertCappedToFlexiModel, callback?: (result) => void): void {
        const client = new ConvertCappedToFlexiClient();
        const promise = client.put(data);
        promise.onSuccess((result) => {
            if (callback) {callback(result);}
        });
    }

    public static submitInstruction(data: ConvertCappedToFlexiModel, callback?): void {
        data.Status = InstructionStatus.Submitted;
        const client = new ConvertCappedToFlexiClient();
        console.log(data)
        const promise = client.put(data);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static deleteInstruction(id, callback?): void {
        Promise.resolve(callback());
    }

    private static updateConvertToFlexiInstructionStore(promise: any) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(ConvertToFlexiInstructionStore.getData()));
            if (!data) {data = {};}
            data = result;
            ConvertToFlexiInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            ConvertToFlexiInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}